var plugin_rtlignore_default = {
  "alignLeft": "_1PhFQ",
  "textWrapNowrap": "yqBDD",
  "alignRight": "zcIeh",
  "alignCenter": "rxF05",
  "sizeFullWidth": "uz-4s",
  "renderedInTable": "H6VTe",
  "sizeOriginal": "SkYEL",
  "sizeContent": "qTNqm",
  "sizeSmall": "mtowC",
  "sizeSmallCenter": "VVDG-",
  "flex": "RD9pQ",
  "atomic": "iwMEp",
  "embed": "yMmGp",
  "horizontalScrollbar": "CBJnW",
  "pluginContainerMobile": "no6ss"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
